import(/* webpackMode: "eager" */ "/vercel/path0/src/app/male-attractiveness-test/page.tsx");
